/**
 * Sysadmin Skills catalog — pure layout route (R5 P0-1 fix, 2026-05-13).
 *
 * Before the fix, this file held both the route registration AND the
 * list-page component. TanStack file-based routing auto-nests the
 * child route `catalog.skills.$id` under this parent, but without an
 * <Outlet/> in the parent component, child routes had nowhere to
 * render and the list stayed mounted for every URL under
 * `/sysadmin/catalog/skills/*`.
 *
 * The list content moved to `catalog.skills.index.tsx` (route ID
 * `/sysadmin/catalog/skills/`). This file is now a pure layout,
 * mirroring the canonical sibling pattern at `routes/sysadmin/models.tsx`.
 */

import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/sysadmin/catalog/skills')({
  component: SkillsCatalogLayout,
});

function SkillsCatalogLayout() {
  return <Outlet />;
}
